const SearchIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    width='121'
    height='128'
    viewBox='0 0 121 128'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M89.8874 77.3274L71.8162 93.2042L102.882 127.281L120.952 111.404L89.8874 77.3274ZM45.1059 87.926C20.552 87.926 0.648438 68.405 0.648438 44.3219C0.648438 20.2414 20.552 0.71875 45.1059 0.71875C69.6598 0.71875 89.5633 20.2414 89.5633 44.3219C89.5633 68.405 69.6598 87.926 45.1059 87.926Z'
      fill='currentColor'
    />
  </svg>
);

export default SearchIcon;
